(() => {
  const productSelector = '[data-product-root]';
  const gloSelector = '.globo-swatch-product-detail';
  const nativeSelector = '[data-variant-picker]';
  const mobilePreviewRequests = new WeakSet();
  const mediaCache = new WeakMap();
  const optionCache = new WeakMap();
  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };
  const mobileLayout = matchMedia('(max-width: 749px)');
  const placeProductOptions = product => {
    const native = product.querySelector(nativeSelector);
    const picker = product.querySelector(gloSelector);
    const summary = product.querySelector('.product-summary');
    const rating = summary?.querySelector('.product-review-rating');
    const purchase = product.querySelector('.purchase');
    let section = product.querySelector('[data-mobile-options]');
    if (!native?.querySelector('[data-option-position] input, [data-option-position] select, [data-option-position] button') || !rating || !purchase) {
      if (section) { section.before(...section.children); section.remove(); }
      return;
    }
    if (mobileLayout.matches) {
      if (!section) {
        section = document.createElement('div');
        section.dataset.mobileOptions = '';
        rating.after(section);
      }
      if (picker && picker.parentElement !== section) section.append(picker);
      if (native.parentElement !== section) section.append(native);
    } else if (section) {
      if (picker) summary.after(picker);
      (picker || summary).after(native);
      section.remove();
    }
  };
  const findNative = input => {
    const product = input.closest(productSelector);
    const native = product?.querySelector(nativeSelector);
    if (!native) return;
    let options = optionCache.get(native);
    if (!options) {
      options = new Map();
      for (const fieldset of native.querySelectorAll('[data-option-position]')) {
        options.set(Number(fieldset.dataset.optionPosition), new Map([...fieldset.querySelectorAll('input[data-option-value-id]')].map(option => [option.value, option])));
      }
      optionCache.set(native, options);
    }
    const position = Number(input.closest('[data-option-index]')?.dataset.optionIndex) + 1;
    return options.get(position)?.get(input.value);
  };
  const readMedia = product => {
    const script = product.querySelector('[data-glo-media]');
    if (!script) return [];
    if (!mediaCache.has(script)) {
      try { mediaCache.set(script, JSON.parse(script.textContent)); }
      catch { mediaCache.set(script, []); }
    }
    return mediaCache.get(script);
  };
  const prepareProduct = product => {
    if (product.getAttribute('aria-busy') !== 'true' || product.hasAttribute('data-variant-error')) product.removeAttribute('data-description-loading');
    const picker = product.querySelector(gloSelector);
    const native = product.querySelector(nativeSelector);
    const hasOptions = Boolean(native?.querySelector('[data-option-position] input, [data-option-position] select, [data-option-position] button'));
    if (native) native.hidden = !hasOptions;
    if (picker) picker.toggleAttribute('data-no-options', !hasOptions);
    if (!picker || !native || !hasOptions) {
      product.removeAttribute('data-glo-active');
      native?.removeAttribute('aria-hidden');
      native?.querySelectorAll('input').forEach(input => input.removeAttribute('tabindex'));
      return;
    }
    const inputs = [...picker.querySelectorAll('input[type="radio"][data-globoswatchindex]')];
    // GPT WORK: Reuse this pass's native mappings; do not cache across product replacement.
    const mappedInputs = [];
    const connected = inputs.length && inputs.every(input => {
      const option = findNative(input);
      mappedInputs.push(option);
      return Boolean(option);
    });
    product.toggleAttribute('data-glo-active', Boolean(connected));
    if (connected) setAttribute(native, 'aria-hidden', 'true');
    else native.removeAttribute('aria-hidden');
    native.querySelectorAll('input').forEach(input => connected ? setAttribute(input, 'tabindex', '-1') : input.removeAttribute('tabindex'));
    if (!connected) return;
    // Finish the reservation as soon as GLO maps to usable native controls.
    native.querySelectorAll('[data-swatch-pending]').forEach(field => {
      field.removeAttribute('data-swatch-pending');
      field.inert = false;
    });
    native.querySelectorAll('[data-swatch-reserve]').forEach(reserve => { reserve.hidden = true; });
    const media = readMedia(product);
    for (let index = 0; index < inputs.length; index++) {
      const input = inputs[index];
      const option = mappedInputs[index];
      if (input.checked !== option.checked) input.checked = option.checked;
      setAttribute(input, 'aria-disabled', option.getAttribute('aria-disabled') || 'false');
      const item = input.closest('li');
      item?.classList.toggle('is-unavailable', option.getAttribute('aria-disabled') === 'true');
      if (input.checked) setAttribute(input, 'checked', '');
      else input.removeAttribute('checked');
      const position = Number(input.closest('[data-option-index]')?.dataset.optionIndex) + 1;
      const anchor = option?.closest('.color-config-section') ? item?.querySelector('.swatch-anchor') : null;
      // GPT WORK: Existing swatch images need no source lookup or replacement.
      const record = anchor && !anchor.querySelector('img') ? media.find(value => value.position === position && value.name === input.value) : null;
      if (record?.image) {
        const image = document.createElement('img');
        image.src = record.image;
        image.style.cssText = 'display:block!important;width:100%!important;height:100%!important;object-fit:contain!important;border-radius:inherit!important;';
        image.alt = record.alt;
        image.loading = index < 8 ? 'eager' : 'lazy';
        image.fetchPriority = 'auto';
        image.decoding = 'async';
        image.width = 96;
        image.height = 80;
        anchor.append(image);
      }
    }
    for (const group of picker.querySelectorAll('[data-option-index]')) {
      const label = group.querySelector('.name-variant');
      const value = group.querySelector('input:checked')?.value;
      if (label && value && label.textContent !== `: ${value}`) label.textContent = `: ${value}`;
    }
  };
  const guardPendingPurchase = event => {
    const control = event.type === 'submit' ? event.target.closest('[data-product-form]') : event.target.closest('.buy-box [data-add-button],.buy-box [data-buy-now],.buy-box #rsi_buy_now_button');
    const product = control?.closest(productSelector);
    if (product?.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  document.addEventListener('click', guardPendingPurchase, true);
  document.addEventListener('submit', guardPendingPurchase, true);
  const prioritizeOptionImage = event => {
    const item = event.target.closest(`${gloSelector} li, ${nativeSelector} label`);
    if (!item) return;
    const input = item.querySelector('input[type="radio"]');
    if (!input) return;
    const native = input.closest(nativeSelector) ? input : findNative(input);
    const mediaId = native?.dataset.optionMediaId;
    const product = input.closest(productSelector);
    if (!mediaId || !product) return;
    const panel = [...product.querySelectorAll('[data-gallery] [data-media-id]')].find(element => element.dataset.mediaId === mediaId);
    const image = panel?.querySelector('img');
    if (image) { image.fetchPriority = 'high'; image.loading = 'eager'; }
  };
  document.addEventListener('pointerover', prioritizeOptionImage, { passive: true });
  document.addEventListener('pointerdown', prioritizeOptionImage, { passive: true });
  document.addEventListener('focusin', prioritizeOptionImage);
  document.addEventListener('change', event => {
    const input = event.target;
    if (event.isTrusted && mobileLayout.matches && input.matches(`${gloSelector} input[type="radio"], ${nativeSelector} input[type="radio"]`)) {
      const product = input.closest(productSelector);
      if (product) mobilePreviewRequests.add(product);
    }
    if (input.matches('.product-card .swatches-globo input[type="radio"]')) {
      const card = input.closest('.product-card');
      const control = [...card.querySelectorAll('.card-color-dot[data-card-variant]')].find(button => button.dataset.cardValueName === input.value);
      if (control) control.click();
      return;
    }
    if (input.matches('[data-variant-picker] input[type="radio"], .globo-swatch-product-detail input[type="radio"]')) {
      const owner = input.closest(productSelector);
      const option = input.closest(nativeSelector) ? input : findNative(input);
      const target = option?.dataset.productUrl;
      if (owner) owner.toggleAttribute('data-description-loading', Boolean(target && new URL(target, location.origin).pathname !== new URL(owner.dataset.productUrl || location.pathname, location.origin).pathname));
    }
    if (!input.matches(`${gloSelector} input[type="radio"][data-globoswatchindex]`)) return;
    const native = findNative(input);
    if (!native) return;
    native.checked = true;
    native.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);
  const revealSelectedMedia = event => {
    const product = event.target.closest(productSelector);
    if (!product || !mobilePreviewRequests.has(product)) return;
    mobilePreviewRequests.delete(product);
    if (!mobileLayout.matches || document.querySelector('#ProductLightbox[open]')) return;
    requestAnimationFrame(() => {
      const image = product.querySelector('[data-gallery] .main-image');
      if (!image || !product.isConnected) return;
      const header = document.querySelector('.site-header');
      let headerContainer = header;
      while (headerContainer && !['sticky', 'fixed'].includes(getComputedStyle(headerContainer).position)) headerContainer = headerContainer.parentElement;
      const offset = headerContainer && header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      const top = Math.max(0, window.scrollY + image.getBoundingClientRect().top - offset - 12);
      if (top < window.scrollY - 1) window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    });
  };
  document.addEventListener('meriavo:variant-preview', revealSelectedMedia);
  document.addEventListener('meriavo:variant-changed', event => {
    const product = event.target.closest(productSelector);
    if (product) { placeProductOptions(product); prepareProduct(product); }
    revealSelectedMedia(event);
  });
  document.addEventListener('focusin', event => {
    const input = event.target;
    if (!input.matches('[data-glo-active] [data-variant-picker] input')) return;
    const product = input.closest(productSelector);
    const target = [...product.querySelectorAll(`${gloSelector} input[type="radio"]`)].find(candidate => findNative(candidate) === input);
    target?.focus({ preventScroll: true });
  });
  let frame = 0;
  const prepareLightbox = () => {
    const box = document.querySelector('#ProductLightbox[open]');
    if (!box) return;
    const product = [...document.querySelectorAll(productSelector)].find(root => root.dataset.productHandle === box.dataset.productHandle);
    if (!product) return;
    const media = readMedia(product);
    let sourceInputs;
    for (const fieldset of box.querySelectorAll('[data-lightbox-option]')) {
      const position = Number(fieldset.dataset.lightboxOption);
      const legend = fieldset.querySelector('legend');
      const selected = fieldset.querySelector('input:checked,select option:checked,[data-option-value][aria-pressed="true"]');
      const value = selected?.value || selected?.dataset.optionValue;
      if (legend && value) {
        let current = legend.querySelector('[data-lightbox-selected-value]');
        if (!current) {
          current = document.createElement('span');
          current.dataset.lightboxSelectedValue = '';
          (legend.querySelector('span') || legend).append(current);
        }
        const text = `: ${value}`;
        if (current.textContent !== text) current.textContent = text;
      } else legend?.querySelector('[data-lightbox-selected-value]')?.remove();
      for (const input of fieldset.querySelectorAll('input[data-option-value-id]')) {
        const swatch = input.parentElement.querySelector('.product-color-swatch');
        if (!swatch || swatch.querySelector('img')) continue;
        const record = media.find(value => value.position === position && value.name === input.value);
        // GPT WORK: Query source controls once, only when this popup needs an image.
        sourceInputs ||= [...product.querySelectorAll(`${gloSelector} input[type="radio"]`)];
        const source = sourceInputs.find(option => option.value === input.value && Number(option.closest('[data-option-index]')?.dataset.optionIndex) + 1 === position);
        const image = source?.closest('li')?.querySelector('.swatch-anchor img');
        if (image?.src || record?.image) {
          const picture = document.createElement('img');
          picture.src = image?.src || record.image;
          picture.alt = input.value;
          picture.width = 44;
          picture.height = 44;
          picture.decoding = 'async';
          swatch.replaceChildren(picture);
        }
      }
    }
  };
  const colorMaps = new WeakMap();
  const sourceProducts = new Map();
  const sourceColorRetryAfter = new Map();
  const pendingColors = new Map();
  const colorButtons = root => root.querySelectorAll('.card-color-dot,.hero-color-dot');
  const setColor = (button, color) => {
    const fill = button.querySelector('.swatch-fill');
    if (fill && color && fill.style.getPropertyValue('--swatch') !== color) fill.style.setProperty('--swatch', color);
  };
  const resolveSourceColors = async (root, colors) => {
    const handle = root.dataset.productHandle;
    if (!handle || !root.isConnected) return;
    if (!sourceProducts.has(handle)) {
      if (Date.now() < (sourceColorRetryAfter.get(handle) || 0)) return;
      sourceProducts.set(handle, fetch(`/products/${encodeURIComponent(handle)}.js`, { priority: 'low', signal: AbortSignal.timeout(10000) })
        .then(response => {
          if (!response.ok) throw new Error('Source color lookup failed');
          return response.json();
        })
        .then(product => {
          if (!Array.isArray(product?.variants)) throw new Error('Invalid source color data');
          sourceColorRetryAfter.delete(handle);
          return new Map(product.variants.map(variant => [String(variant.id), variant.options]));
        })
        .catch(() => {
          sourceProducts.delete(handle);
          sourceColorRetryAfter.set(handle, Date.now() + 30000);
          return new Map();
        }));
    }
    root.setAttribute('data-swatch-pending', '');
    const variants = await sourceProducts.get(handle);
    root.removeAttribute('data-swatch-pending');
    if (!root.isConnected) return;
    for (const button of colorButtons(root)) {
      const values = variants.get(button.dataset.cardVariant);
      const position = Number(button.dataset.cardOptionPosition);
      if (values && position > 0) setColor(button, colors.get(values[position - 1]));
    }
  };
  const colorObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) {
      const colors = pendingColors.get(entry.target);
      pendingColors.delete(entry.target);
      colorObserver.unobserve(entry.target);
      if (colors) resolveSourceColors(entry.target, colors);
    }
  }, { rootMargin: '200px' }) : null;
  const paintNativeColors = root => {
    const options = window.GloboSwatchConfig?.options || window.globoswatch?.optionsApp;
    if (!Array.isArray(options)) return;
    let colors = colorMaps.get(options);
    if (!colors) {
      colors = new Map();
      for (const option of options) for (const item of option.option_items || []) {
        const custom = item.custom || {};
        const color = custom.enable_two_color && custom.color_2 && custom.color_2 !== 'transparent'
          ? `linear-gradient(-45deg,${custom.color_2} 50%,${custom.color_1} 50%)`
          : custom.color_1;
        if (color && CSS.supports('background', color)) colors.set(item.value, color);
      }
      colorMaps.set(options, colors);
    }
    let missing = false;
    for (const button of colorButtons(root)) {
      if (!button.querySelector('.swatch-fill')) continue;
      const color = colors.get(button.dataset.cardValueName);
      if (color) setColor(button, color);
      else missing = true;
    }
    if (missing) {
      if (colorObserver) {
        if (!pendingColors.has(root)) {
          pendingColors.set(root, colors);
          colorObserver.observe(root);
        }
      } else resolveSourceColors(root, colors);
    }
  };
  const prepareCard = card => paintNativeColors(card);
  const pendingProducts = new Set();
  const pendingCards = new Set();
  const deferredCards = new Set();
  let pendingLightbox = false;
  const flushProducts = () => {
    const products = [...pendingProducts];
    pendingProducts.clear();
    for (const product of products) if (product.isConnected) {
      placeProductOptions(product);
      prepareProduct(product);
    }
  };
  const flush = () => {
    frame = 0;
    flushProducts();
    const cards = [...pendingCards];
    pendingCards.clear();
    for (const card of deferredCards) {
      if (!card.isConnected) deferredCards.delete(card);
      else if (!card.closest('dialog:not([open])')) { deferredCards.delete(card); cards.push(card); }
    }
    for (const card of new Set(cards)) if (card.isConnected) {
      if (card.closest('dialog:not([open])')) deferredCards.add(card);
      else prepareCard(card);
    }
    if (pendingLightbox) { pendingLightbox = false; prepareLightbox(); }
  };
  const schedule = () => {
    if (!frame && (pendingProducts.size || pendingCards.size || pendingLightbox)) frame = requestAnimationFrame(flush);
  };
  const productDependencies = `${gloSelector},${nativeSelector},.product-summary,.purchase,.product-review-rating,[data-mobile-options],[data-glo-media]`;
  const lightboxDependencies = '[data-lightbox-variants],[data-lightbox-option]';
  const cardDependencies = '.card-color-dot,.hero-color-dot,.swatch-fill,.swatches-globo';
  const containsDependency = (node, selector) => node.nodeType === 1 && (node.matches(selector) || Boolean(node.querySelector(selector)));
  const affectsDependency = (record, selector) => Boolean(record.target.closest?.(selector)) || [...record.addedNodes, ...record.removedNodes].some(node => containsDependency(node, selector));
  const collect = node => {
    if (node.nodeType !== 1) return;
    const product = node.closest(productSelector);
    const card = node.closest('.product-card');
    if (product && (node.closest(productDependencies) || containsDependency(node, productDependencies))) pendingProducts.add(product);
    if (card && (node.closest(cardDependencies) || containsDependency(node, cardDependencies))) pendingCards.add(card);
    node.querySelectorAll(productSelector).forEach(root => pendingProducts.add(root));
    node.querySelectorAll('.product-card').forEach(root => pendingCards.add(root));
    if (node.closest('#ProductLightbox') && (node.closest(lightboxDependencies) || containsDependency(node, lightboxDependencies)) || node.querySelector('#ProductLightbox')) pendingLightbox = true;
  };
  const refresh = () => {
    document.querySelectorAll('[data-hero-summary]').forEach(paintNativeColors);
    document.querySelectorAll(productSelector).forEach(root => pendingProducts.add(root));
    document.querySelectorAll('.product-card').forEach(root => pendingCards.add(root));
    pendingLightbox = true;
    flushProducts();
    schedule();
  };
  window.addEventListener('Globo.swatch.collection.loaded', refresh);
  const observer = new MutationObserver(records => {
    for (const record of records) {
      const target = record.target;
      if (target.nodeType === 1) {
        const product = target.closest(productSelector);
        const card = target.closest('.product-card');
        if (product && affectsDependency(record, productDependencies)) pendingProducts.add(product);
        if (card && affectsDependency(record, cardDependencies)) pendingCards.add(card);
        if (target.closest('#ProductLightbox') && affectsDependency(record, lightboxDependencies)) pendingLightbox = true;
      }
      record.addedNodes.forEach(collect);
    }
    if (pendingColors.size && records.some(record => record.removedNodes.length)) {
      for (const root of pendingColors.keys()) if (!root.isConnected) {
        colorObserver?.unobserve(root);
        pendingColors.delete(root);
      }
    }
    flushProducts();
    schedule();
  });
  const observe = () => observer.observe(document.body, { childList: true, subtree: true });
  const lightbox = document.querySelector('#ProductLightbox');
  const lightboxObserver = new MutationObserver(() => { pendingLightbox = true; schedule(); });
  const observeLightbox = () => { if (lightbox) lightboxObserver.observe(lightbox, { attributes: true, attributeFilter: ['open'] }); };
  const overlayObserver = new MutationObserver(records => {
    for (const record of records) if (record.target.open) {
      record.target.querySelectorAll('.product-card').forEach(card => pendingCards.add(card));
    }
    schedule();
  });
  const observeOverlays = () => document.querySelectorAll('#CartDrawer,#SearchOverlay').forEach(dialog => overlayObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] }));
  window.addEventListener('pagehide', () => {
    observer.disconnect();
    colorObserver?.disconnect();
    pendingColors.clear();
    lightboxObserver.disconnect();
    overlayObserver.disconnect();
    cancelAnimationFrame(frame);
    frame = 0;
    pendingProducts.clear();
    pendingCards.clear();
    deferredCards.clear();
    pendingLightbox = false;
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { observe(); observeLightbox(); observeOverlays(); } refresh(); });
  mobileLayout.addEventListener('change', refresh);
  observe();
  observeLightbox();
  observeOverlays();
 
  refresh();
})();






